import type { OpeningHours } from 'app/components/commons/Hotel/Types';
import type { Picture } from 'app/components/commons/Uploader/Types';
import type { ExperienceCategory } from 'app/redux/models/ExperienceCategory/ExperienceCategory';
import type { ExperienceFieldType } from 'app/typings/experiences';
import type { Dayjs } from 'app/utils/dayjs';

export enum DurationDescription {
  MINUTE = 'minutes',
  HOUR = 'hours',
  HALF_DAY = 'half-days',
  DAY = 'days',
}

export type IExperience = {
  hotelId: number;
  categoryId: number;
  spaceIds: number[];
  name: string | null;
  description: string | null;
  coverPicture: Picture;
  emoji: Picture | null;
  pictures: Picture[];
  included?: boolean;
  price: number | null;
  priceDescription: number | null;
  openingHours: OpeningHours | null;
  published: boolean;
  id: number;
  brand: string | null;
  quantity: number | null;
  quantityDescription: string | null;
  duration: number | null;
  durationDescription: DurationDescription | null;
  time: Dayjs | string | null;
  roomServiceAvailable: boolean;
  roomServiceIncluded: boolean;
  roomServicePrice: number | null;
  accessMode: string | null;
  locations: string | null;
};

export type IExperienceListElement = {
  hotelId: number;
  hotelName: string;
  coverPicture: Picture;
  price: number | null;
  published: boolean;
  id: number;
  brand: string | null;
  quantity: number | null;
  duration: number | null;
  durationDescription: string | null;
  time: Dayjs | string | null;
  locations: string | null;
  updatedAt: string;
  countryId: number;
  category: IExperienceCategory;
};

export type IExperienceCategory = {
  id: number;
  parentId?: number;
  pictureId: number;
  name: string;
  experienceType: string;
  accessMode: boolean;
  brand: boolean;
  duration: boolean;
  time: boolean;
  locations: boolean;
  openingHours: ExperienceFieldType;
  price: boolean;
  priceDescription: boolean;
  quantity: boolean;
  quantityDescription: boolean;
  quantityTitle: boolean;
  roomService: boolean;
  spaces: boolean;
  menu: boolean;
  treatmentList: boolean;
};

export type ExperienceNameArg = {
  category: IExperienceCategory | ExperienceCategory | null | undefined;
  quantity: number | null;
  brand: string | null;
  duration: number | null;
  durationDescription: string | null;
  time: Dayjs | Date | string | null;
  locations: string | null;
};
